import React from "react";
import OrganizingTeam from "../../components/OrgnizingTeam";
import EventSchedule from "../../components/EventSchedule";
import OurSponsors from "../../components/OurSponsors";
import HeroComponent from "../../components/Hero";
import SpeakerComponent from "../../components/Speaker";

export default function Home() {
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero Section */}
            <section id="home" className="relative bg-white overflow-hidden">
                <HeroComponent />
            </section>

            {/* Speaker Section */}
            <section id="speakers" className="py-24 relative">
                <SpeakerComponent />
            </section>

            {/* Team Section */}
            <section id="team" className="py-24 bg-white">
                <OrganizingTeam />
            </section>

            {/* Schedule Section */}
            <section id="schedule" className="py-24 bg-gray-50">
                <EventSchedule />
            </section>

            {/* Sponsors Section */}
            <section id="sponsors" className="py-12 bg-white">
                <OurSponsors />
            </section>
        </div>
    );
}
